module.exports = __webpack_public_path__ + "static/media/ball.d63a0740.svg";